import dayjs from 'dayjs';
import { PLAN_TAX } from './plan';
const CAMPAIGN_PLAN_AMOUNT = 1980;
export class CoachingPlan {
    constructor(coachingPlanData) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "stripePlanId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "amount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "planType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "renewalDayFromNow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = coachingPlanData.id;
        this.stripePlanId = coachingPlanData.stripePlanId;
        this.name = coachingPlanData.name;
        this.amount = coachingPlanData.amount;
        this.planType = coachingPlanData.planType;
        this.renewalDayFromNow = dayjs.unix(coachingPlanData.renewalDayFromNow);
    }
    get isStandardPlan() {
        return this.planType === 'standard';
    }
    get isCampaignPlan() {
        return this.amount === CAMPAIGN_PLAN_AMOUNT;
    }
    get excludeTaxAmount() {
        return this.amount / PLAN_TAX;
    }
}
